import LoadingScreen from './LoadingScreen';

import { useState, useEffect } from 'react';

export default function PageLoader({ loading, minDuration = 0, showOnMountDuration = 300, children }) {
  const [show, setShow] = useState(loading);

  useEffect(() => {
    let timer;
    // when loading turns on, always show immediately
    if (loading) {
      setShow(true);
      if (minDuration > 0) {
        // ensure at least minDuration visible
        timer = setTimeout(() => {
          if (!loading) setShow(false);
        }, minDuration);
      }
    } else {
      if (minDuration > 0) {
        // keep visible for minDuration after loading finishes
        timer = setTimeout(() => setShow(false), minDuration);
      } else {
        setShow(false);
      }
    }
    return () => timer && clearTimeout(timer);
  }, [loading, minDuration]);

  // show briefly on first mount so F5 shows a loading screen (configurable)
  useEffect(() => {
    if (!loading && showOnMountDuration > 0) {
      setShow(true);
      const t = setTimeout(() => setShow(false), showOnMountDuration);
      return () => clearTimeout(t);
    }
    return undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (show) return <LoadingScreen />;
  return children;
}
